import { create } from "zustand";

const useLoaderStore = create((set) => ({
  requestCount: 0,

  showLoader: () =>
    set((state) => ({
      requestCount: state.requestCount + 1,
    })),

  hideLoader: () =>
    set((state) => ({
      requestCount: Math.max(0, state.requestCount - 1),
    })),
}));

export default useLoaderStore;